module.exports = __webpack_public_path__ + "static/media/S (14).dbc282db.jpg";